import CardMapPanel from './CardMapPanel';
export default CardMapPanel;
